<template>
  <DashboardHeader title="Print Reports">
    <ReportsDesigner :tables="tables"></ReportsDesigner>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import ReportsDesigner from "@/components/myLibrary/ReportsDesigner.vue";

export default {
  components: {
    DashboardHeader,
    ReportsDesigner
  },

  data() {
    return {
      tables: [
        {
          text: "Classes",
          value: "classes",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Payments",
          value: "incomes",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Students",
          value: "students",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Application Dates",
          value: "application_dates",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Fees Amounts",
          value: "fees_all_times",
          alevel: [9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Future Billings",
          value: "future_billing",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Staff Roles",
          value: "staff_roles",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Staff Earnings",
          value: "earnings",
          alevel: [9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Staff Deductions",
          value: "deductions",
          alevel: [9, 10, 11, 12, 13, 14, 15]
        },

        {
          text: "Expense Categories",
          value: "expenses_categories",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Income Categories",
          value: "incomes_categories",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Contact Groups",
          value: "sms_groups",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Contacts",
          value: "sms_contacts",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Terms",
          value: "terms",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Reports Comments",
          value: "comments",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },

        {
          text: "Blocked Reports",
          value: "blocked_reports",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Web Enquiries",
          value: "contact_us",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Service Providers",
          value: "service_providers",
          alevel: [9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "School Numbers",
          value: "contact_numbers",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Users",
          value: "users",
          alevel: [9, 10, 11, 12, 13, 14, 15]
        }
      ]
    };
  }
};
</script>
